function datetime(){

}
datetime.prototype.options={};
datetime.prototype.render=function(options){
     this.options=options;
     
}
export { datetime };